var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"DlIpBmCkguT4SAlN5S87U"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["projektfabrik@futureprojects"]={id:"DlIpBmCkguT4SAlN5S87U"};
      